import { SideMenuI } from '../../../shared/interfaces/side-menu.interface';

export const SIDE_MENU_ITEMS: SideMenuI[] = [
  {
    title: 'Dashboard',
    route: 'dashboard',
    translationPath: 'sideMenu.dashboard',
    activeIcon: 'svgs/side-menu/active-dashboard.svg',
    inactiveIcon: 'svgs/side-menu/inactive-dashboard.svg',
    roles: [],
  },
  {
    title: 'Collections',
    route: 'collections',
    translationPath: 'sideMenu.collections',
    activeIcon: 'svgs/side-menu/active-collections.svg',
    inactiveIcon: 'svgs/side-menu/inactive-collections.svg',
    roles: [],
  },
  {
    title: 'Product Tags',
    route: 'product-tags',
    translationPath: 'sideMenu.productTags',
    activeIcon: 'svgs/side-menu/active-product-tag.svg',
    inactiveIcon: 'svgs/side-menu/inactive-product-tag.svg',
    roles: [],
  },
  {
    title: 'Categories',
    route: 'categories',
    translationPath: 'sideMenu.categories',
    activeIcon: 'svgs/side-menu/active-categories.svg',
    inactiveIcon: 'svgs/side-menu/inactive-categories.svg',
    roles: [],
  },
  {
    title: 'Sub Categories',
    route: 'sub-categories',
    translationPath: 'sideMenu.subCategories',
    activeIcon: 'svgs/side-menu/active-subcategories.svg',
    inactiveIcon: 'svgs/side-menu/inactive-subcategories.svg',
    roles: [],
  },

  {
    title: 'Target Groups',
    route: 'target-groups',
    translationPath: 'sideMenu.targetGroups',
    activeIcon: 'svgs/side-menu/active-countries.svg',
    inactiveIcon: 'svgs/side-menu/inactive-countries.svg',
    roles: [],
  },
  {
    title: 'Countries',
    route: 'countries',
    translationPath: 'sideMenu.countries',
    activeIcon: 'svgs/side-menu/active-countries.svg',
    inactiveIcon: 'svgs/side-menu/inactive-countries.svg',
    roles: [],
  },
  {
    title: 'Cities',
    route: 'cities',
    translationPath: 'sideMenu.cities',
    activeIcon: 'svgs/side-menu/active-cities.svg',
    inactiveIcon: 'svgs/side-menu/inactive-cities.svg',
    roles: [],
  },
  {
    title: 'Brands',
    route: 'brands',
    translationPath: 'sideMenu.brands',
    activeIcon: 'svgs/side-menu/active-brands.svg',
    inactiveIcon: 'svgs/side-menu/inactive-brands.svg',
    roles: [],
  },
  {
    title: 'Products',
    route: 'products',
    translationPath: 'sideMenu.products',
    activeIcon: 'svgs/side-menu/active-products-details.svg',
    inactiveIcon: 'svgs/side-menu/inactive-products-details.svg',
    roles: [],
  },
  {
    title: 'Ads',
    route: 'ads',
    translationPath: 'sideMenu.ads',
    activeIcon: 'svgs/side-menu/active-ads.svg',
    inactiveIcon: 'svgs/side-menu/inactive-ads.svg',
    roles: [],
  },
  {
    title: 'Finance Management',
    route: 'finance-management',
    translationPath: 'sideMenu.financeManagement',
    activeIcon: 'svgs/side-menu/active-finance-management.svg',
    inactiveIcon: 'svgs/side-menu/inactive-finance-management.svg',
    roles: [],
  },
  {
    title: 'Promo Code',
    route: 'promo-codes',
    translationPath: 'sideMenu.promoCodes',
    activeIcon: 'svgs/side-menu/active-promo-codes.svg',
    inactiveIcon: 'svgs/side-menu/inactive-promo-codes.svg',
    roles: [],
  },
  {
    title: 'Merchants',
    route: 'merchants',
    translationPath: 'sideMenu.merchants',
    activeIcon: 'svgs/side-menu/active-merchants.svg',
    inactiveIcon: 'svgs/side-menu/inactive-merchants.svg',
    roles: [],
  },
  {
    title: 'Top Merchants',
    route: 'top-merchants',
    translationPath: 'sideMenu.topMerchants',
    activeIcon: 'svgs/side-menu/active-top-merchants.svg',
    inactiveIcon: 'svgs/side-menu/inactive-top-merchants.svg',
    roles: [],
  },
  {
    title: 'Merchant Tiers',
    route: 'merchants-tiers',
    translationPath: 'sideMenu.merchantTiers',
    activeIcon: 'svgs/side-menu/active-merchant-tiers.svg',
    inactiveIcon: 'svgs/side-menu/inactive-merchant-tiers.svg',
    roles: [],
  },
  {
    title: 'Notifications',
    route: 'notifications',
    translationPath: 'sideMenu.notifications',
    activeIcon: 'svgs/side-menu/active-notifications.svg',
    inactiveIcon: 'svgs/side-menu/inactive-notifications.svg',
    roles: [],
  },
  {
    title: 'Orders',
    route: 'orders',
    translationPath: 'sideMenu.orders',
    activeIcon: 'svgs/side-menu/active-orders.svg',
    inactiveIcon: 'svgs/side-menu/inactive-orders.svg',
    roles: [],
  },
  {
    title: 'Support',
    route: 'support/merchants',
    translationPath: 'sideMenu.supportRequests',
    activeIcon: 'svgs/side-menu/active-support.svg',
    inactiveIcon: 'svgs/side-menu/inactive-support.svg',
    roles: [],
  },
  {
    title: 'Customers',
    route: 'customers',
    translationPath: 'sideMenu.customers',
    activeIcon: 'svgs/side-menu/active-customers.svg',
    inactiveIcon: 'svgs/side-menu/inactive-customers.svg',
    roles: [],
  },
];
